import { render, staticRenderFns } from "./TranslationReset.vue?vue&type=template&id=b4b8aa6c&scoped=true"
import script from "./TranslationReset.vue?vue&type=script&lang=js"
export * from "./TranslationReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b8aa6c",
  null
  
)

export default component.exports